function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M32 16.098C32 7.206 24.837 0 16 0 7.162 0 0 7.206 0 16.098 0 24.133 5.85 30.793 13.5 32V20.75H9.437v-4.652H13.5V12.55c0-4.034 2.387-6.263 6.044-6.263 1.75 0 3.581.314 3.581.314v3.962h-2.019c-1.987 0-2.606 1.242-2.606 2.515v3.018h4.438l-.71 4.654H18.5V32C26.15 30.793 32 24.134 32 16.098z",
  fill: "#1877F2"
});

function SvgFacebook24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMyIDE2LjA5NzVDMzIgNy4yMDYxMyAyNC44Mzc1IDAgMTYgMEM3LjE2MjUgMCAwIDcuMjA2MTMgMCAxNi4wOTc1QzAgMjQuMTMzNiA1Ljg1IDMwLjc5MjcgMTMuNSAzMlYyMC43NTA2SDkuNDM3NVYxNi4wOTc1SDEzLjVWMTIuNTUxQzEzLjUgOC41MTcxOSAxNS44ODc1IDYuMjg4MDcgMTkuNTQzOCA2LjI4ODA3QzIxLjI5MzggNi4yODgwNyAyMy4xMjUgNi42MDI0OCAyMy4xMjUgNi42MDI0OFYxMC41NjRIMjEuMTA2M0MxOS4xMTg4IDEwLjU2NCAxOC41IDExLjgwNTkgMTguNSAxMy4wNzkyVjE2LjA5NzVIMjIuOTM3NUwyMi4yMjgxIDIwLjc1MDZIMTguNVYzMkMyNi4xNSAzMC43OTI3IDMyIDI0LjEzMzYgMzIgMTYuMDk3NVoiIGZpbGw9IiMxODc3RjIiLz4KPC9zdmc+Cg==";
export { SvgFacebook24 as ReactComponent };